<div class="bid-term-of-service">
  <app-counter-bid-disclosure class="mb-3" />
  <app-user-terms />
  <app-agree-terms [view]="isUserBidder && !isOhio ? TermsAgreeViewType.NORMAL : TermsAgreeViewType.INTRO" />

  @if (!isUserBidder || (isUserBidder && isOhio)) {
    @if (!isUserBidder) {
      <br /><br />
    }
    @if (isUserInvestor) {
      <app-investor-terms />
    }
    @if (isUserAgent) {
      <app-agent-terms />
    }
    @if (!isUserBidder) {
      <app-agree-terms [isExtraCondition]="true" [view]="TermsAgreeViewType.ACTION" />
    }
    @if (isOhio) {
      <br /><br />
      @if (isOhio) {
        <app-user-terms-ohio />
      }
      <app-agree-terms [isExtraCondition]="true" [view]="TermsAgreeViewType.INTRO" />
      <app-agree-terms [view]="TermsAgreeViewType.ACTION" />
    }
  }

  <div class="separator"></div>

  <!-- PROPERTY DISCLOSURES -->
  <div class="disclosures-wrapper">
    @if (disclosures$ | async; as disclosures) {
      <h6 class="disclosures-title">Property Disclosures:</h6>
      @for (document of disclosures; track document) {
        <a target="_blank" class="d-block" [href]="document.DISCLOSUREPATH" rel="noreferrer noreopen">
          {{ document.DISCLOSURENAME }}
        </a>
      }
    }
  </div>
</div>
